export const boolean = {
  type: "boolean"
};
